export const QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE = 'next_redirect_url';
